import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_filter_list_element = _resolveComponent("filter-list-element")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputItems, (element, index) => {
    return (_openBlock(), _createElementBlock(_Fragment, {
      key: 'filt_'+index
    }, [
      (!_ctx.excludeDescriptors.includes(element.Descriptor))
        ? (_openBlock(), _createBlock(_component_filter_list_element, {
            key: 0,
            modelValue: _ctx.inputItems[index],
            "onUpdate:modelValue": ($event: any) => ((_ctx.inputItems[index]) = $event),
            "input-index": index,
            "owner-identity": _ctx.ownerIdentity,
            "parent-id": undefined,
            "parent-name": '',
            "parent-idx": 'filt_'+index
          }, null, 8, ["modelValue", "onUpdate:modelValue", "input-index", "owner-identity", "parent-idx"]))
        : _createCommentVNode("", true)
    ], 64))
  }), 128))
}